var GoogleLoginUxMode = /*#__PURE__*/ function(GoogleLoginUxMode) {
    GoogleLoginUxMode["Popup"] = "popup";
    GoogleLoginUxMode["Redirect"] = "redirect";
    return GoogleLoginUxMode;
}({});

export { GoogleLoginUxMode as G };
